import type {
  FreeToPlayTeaserPayload,
  ProductCatalogElement,
  TeaserPayload,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export const useFreeToPlay = () => {
  const {
    feature: { f2pLoyalty: isF2pLoyaltyEnabled },
  } = useRuntimeConfig().public

  const filterFreeToPlayTeasers = <T extends TeaserPayload>(teasers: T[] | undefined) => {
    let filteredTeasers: T[] = []

    if (isF2pLoyaltyEnabled) {
      filteredTeasers = teasers ?? []
    } else {
      filteredTeasers =
        teasers?.filter((teaser) => teaser.__typename !== 'FreeToPlayTeaserPayload') ?? []
    }
    return filteredTeasers
  }

  const isFreeToPlayTeaser = (teaser: ProductCatalogElement): teaser is FreeToPlayTeaserPayload =>
    teaser?.__typename === 'FreeToPlayTeaserPayload'

  return { filterFreeToPlayTeasers, isFreeToPlayTeaser }
}
